import dayjs from "dayjs";
import { axiosInstance } from "services/axios";

export const exportCSV = async ({
  url,
  filenamePrefix,
  params = {},
}: {
  url: string;
  filenamePrefix: string;
  params?: Record<string, any>;
}) => {
  try {
    const response = await axiosInstance.get(url, {
      params,
      responseType: "blob",
      headers: {
        Accept: "text/csv",
      },
    });

    const blob = new Blob([response.data], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.setAttribute(
      "download",
      `${filenamePrefix}_${dayjs().format("YYYY-MM-DD_HH-mm-ss")}.csv`
    );
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(link.href);
  } catch (error) {
    console.error("Erro ao exportar CSV:", error);
    throw error;
  }
};

export const exportText = async ({
  url,
  filenamePrefix,
  params = {},
}: {
  url: string;
  filenamePrefix: string;
  params?: Record<string, any>;
}) => {
  try {
    const response = await axiosInstance.get(url, {
      params,
      responseType: "text",
      headers: {
        Accept: "text/plain",
      },
    });

    const blob = new Blob([response.data], {
      type: "text/plain;charset=utf-8;",
    });

    const link = document.createElement("a");
    const objectUrl = window.URL.createObjectURL(blob);

    link.href = objectUrl;
    link.setAttribute(
      "download",
      `${filenamePrefix}_${dayjs().format("YYYY-MM-DD_HH-mm-ss")}.txt`
    );

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(objectUrl);
  } catch (error: any) {
    console.error("Erro ao exportar CSV:", error);

    if (error?.response?.status === 404) {
      throw new Error(
        "Não foram encontradas informações para os filtros informados."
      );
    }

    throw error;
  }
};
